import React from 'react';
import NavBar from '../components/NavBar';
import CarouselComponent from '../components/CarouselComponent';
import HeroImg from '../components/HeroImg';
import ScrollableGallery from '../components/ScrollableGallery';

function Home() {
  return (
    <div className="page-shell">
      <NavBar />
      <HeroImg />
      <CarouselComponent />
      <ScrollableGallery />
    </div>
  );
}

export default Home;
